import { render, staticRenderFns } from "./input-select-radio.vue?vue&type=template&id=4a1c3ec1&"
import script from "./input-select-radio.component.ts?vue&type=script&lang=ts&"
export * from "./input-select-radio.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports